/**
 * Browser-only download helpers for pricing-request exports (MVP 3.3.1 / 3.3.2).
 * No PII should be written into analytics from these files.
 */
export function downloadTextFile(filename: string, contents: string, mimeType = 'text/plain'): void {
  if (typeof document === 'undefined') {
    return;
  }
  const blob = new Blob([contents], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

export function toCsv(rows: Array<Record<string, string | number | undefined | null>>): string {
  if (!rows.length) {
    return '';
  }
  const headers = Object.keys(rows[0]);
  const escape = (value: string | number | undefined | null) => {
    const text = value == null ? '' : String(value);
    if (/[",\n\r]/.test(text)) {
      return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
  };
  return [headers.join(','), ...rows.map(row => headers.map(h => escape(row[h])).join(','))].join('\n');
}
